import { supabase } from './supabase'

export async function logMenuChange(
  eventId: string,
  userId: string | null,
  action: 'INSERT' | 'UPDATE' | 'DELETE',
  oldData: any,
  newData: any
) {
  try {
    await supabase.from('audit_logs').insert({
      user_id: userId,
      table_name: 'event_menu_items',
      record_id: eventId,
      action,
      old_data: oldData,
      new_data: newData,
    })
  } catch (error) {
    console.error('Error logging menu change:', error)
    // Don't throw - logging failures shouldn't break the main operation
  }
}


